export var CONTAINER_TEST_ID = 'variation-row';
export var UPSELL_TEST_ID = 'upsell';
export var VARIATION_CONTAINER_TEST_ID = 'variation-container';
export var PRICE_CONTAINER_TEST_ID = 'price-container';
export var Size = /*#__PURE__*/function (Size) {
  Size["COMPACT"] = "compact";
  Size["DEFAULT"] = "default";
  return Size;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/ProductVariationRow/constants.js
// module id = 850
// module chunks = 11